<template>
  <div class="container-fluid">
    <router-view class="flex-grow-1" />
  </div>
</template>

<script>
export default {};
</script>
